import React, { Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import { money, percent } from '../../utils/discountFormat';

/** One client's simulator result: legacy / new snapshots side by side plus the diff. */
export default class SimulationResult extends Component {
    render() {
        var r = this.props.result;
        var engines = Object.keys(r.runs);
        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h2 style={{ margin: 0 }}>{r.client_name} <small><Link to={`/clients/${r.client_id}`}>client</Link></small></h2>
                </div>
                <div className="panel-body">
                    <div className="row">
                        {engines.map(engine =>
                            <div key={engine} className={engines.length > 1 ? 'col-md-6' : 'col-md-12'}>
                                <h4>{engine === 'new' ? 'New engine' : 'Legacy'} {r.runs[engine].error && <span className="label label-danger">error</span>}</h4>
                                {r.runs[engine].error && <div className="alert alert-danger">{r.runs[engine].error}</div>}
                                {r.runs[engine].snapshot && <Snapshot snapshot={r.runs[engine].snapshot} />}
                                {!r.runs[engine].snapshot && !r.runs[engine].error && <p className="text-muted">No invoice for this period (nothing billable).</p>}
                            </div>
                        )}
                    </div>
                    {r.diff && <Diff title="Legacy vs new" diff={r.diff} />}
                    {r.diff_vs_actual && <Diff title="Simulated vs the real invoice (informational)" diff={r.diff_vs_actual} informational />}
                </div>
            </div>
        );
    }
}

class Snapshot extends Component {
    render() {
        var s = this.props.snapshot;
        // InvoiceSnapshot: totals {subtotal, discount, tax, total}; each line
        // carries discount_rate/discount_amount and `discounts`, the engine's
        // attribution rows ({client_discount_id (null = manual), description, ...}).
        var t = s.totals || {};
        var discount = t.discount;
        var tax = t.tax;
        return (
            <div>
                {(s.groups || []).map((g, gi) =>
                    <table key={gi} className="table table-condensed">
                        <thead>
                            <tr><th colSpan={5}>{g.name}</th></tr>
                            <tr><th>Line</th><th className="text-right">Qty</th><th className="text-right">Price</th><th className="text-right">Discount</th><th>Winner</th></tr>
                        </thead>
                        <tbody>
                            {(g.lines || []).map((l, li) =>
                                <tr key={li}>
                                    <td>
                                        {l.name}
                                        {l.start && l.end && <div className="text-muted"><small>{moment(l.start).format('D MMM')} – {moment(l.end).subtract(1, 'second').format('D MMM')}</small></div>}
                                    </td>
                                    <td className="text-right">{l.quantity}</td>
                                    <td className="text-right">{money(l.price)}</td>
                                    <td className="text-right">{Number(l.discount_rate) > 0 ? `${money(l.discount_amount)} (${percent(l.discount_rate)})` : '–'}</td>
                                    <td>{(l.discounts || []).map((a, ai) => <div key={ai}><small>{a.description || (a.client_discount_id ? 'campaign' : 'manual')}</small></div>)}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
                <dl className="dl-horizontal" style={{ marginBottom: 0 }}>
                    <dt>Subtotal</dt><dd>{money(t.subtotal)}</dd>
                    <dt>Discount</dt><dd>{money(discount)}</dd>
                    <dt>Tax</dt><dd>{money(tax)}</dd>
                    <dt>Total</dt><dd><strong>{money(t.total)}</strong></dd>
                </dl>
            </div>
        );
    }
}

class Diff extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    render() {
        var { title, diff, informational } = this.props;
        var summary;
        if (diff.rows.length === 0) {
            summary = <span className="text-success">identical</span>;
        } else if (diff.unexplained > 0 && !informational) {
            summary = <span className="text-danger"><strong>{diff.unexplained} unexplained</strong></span>;
        } else {
            summary = <span className="text-success">{diff.rows.length} difference{diff.rows.length === 1 ? '' : 's'}, all explained by campaigns</span>;
        }
        return (
            <div style={{ marginTop: 10 }}>
                <h4>{title}: {summary}
                    {diff.rows.length > 0 && <small> <a href="#" onClick={e => { e.preventDefault(); this.setState({ open: !this.state.open }); }}>{this.state.open ? 'hide rows' : 'show rows'}</a></small>}
                </h4>
                {this.state.open && <pre style={{ maxHeight: 300, overflow: 'auto', fontSize: 11 }}>{JSON.stringify(diff.rows, null, 2)}</pre>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/discounts/SimulationResult.js